import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import Counter from '../Counter/Counter';

const ExpireWarning = observer(class ExpireWarning extends React.Component {
  constructor() {
    super();
    this.confirmKey = this.confirmKey.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.confirmKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.confirmKey, false);
  }

  confirmKey(e) {
    e.preventDefault();

    if(e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) {
      this.closeDialog(e);
    }
  }

  closeDialog(e) {
    if(e) {
      e.preventDefault();
    }

    this.props.store.SessionStore.closeDialog();
  }

  extendSession(e) {
    e.preventDefault();
    this.props.store.SessionStore.extendSession(this.closeDialog);
  }

  render() {
    const { translation } = this.props;
    const endDate = moment().add(2, 'minutes');

    return(
      <div className="dialog dialog--confirm dialog--expire">
        <div className="dialog__content">
          <strong className="dialog__msg" tabIndex="0">
            {translation.heading}

            <Counter endDate={endDate} {...this.props} />
          </strong>

          <p>{translation.body}</p>

          <div className="dialog__btns">
            <a href="#app" className="btn" onClick={(e) => this.extendSession(e)}>{translation.button}</a>
          </div>
        </div>
      </div>
    );
  }
})

export default translate('ExpireWarning')(ExpireWarning);


// WEBPACK FOOTER //
// ./src/app/components/Common/ExpireWarning.js